/** User-friendly product names (no ERP/POS jargon) for landing & pricing. */
export const PRODUCT_TERMS = {
  fr: {
    erp: 'système de gestion',
    erpCap: 'Système de gestion',
    pos: 'point de vente',
    posCap: 'Point de vente',
    posSystem: 'système point de vente',
    posSystemCap: 'Système point de vente',
  },
  ar: {
    erp: 'نظام التسيير',
    erpCap: 'نظام التسيير',
    pos: 'نقطة البيع',
    posCap: 'نقطة البيع',
    posSystem: 'نظام نقطة البيع',
    posSystemCap: 'نظام نقطة البيع',
  },
};

export function getProductTerms(language = 'fr') {
  return PRODUCT_TERMS[language === 'ar' ? 'ar' : 'fr'];
}
